import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "date",
    type: "date",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return <ResourceListPage url="vacation-days" columns={columns} />;
}
